module.exports = __webpack_public_path__ + "img/logo.43c6ae52.png";